module.exports = __webpack_public_path__ + "img/tuboparacercas.7283d62c.jpg";